/**
 * Interface to KryptonRedirectIFrame function that should be accessed from
 * different location in ghost.
 * See comment of this components' function for further details.
 *
 * @since KJS-6361
 */
export default {
  methods: {
    refreshPassContainer() {
      return this.$refs.redirectIframe.refreshPassContainer()
    },
    getPassContainerId() {
      return this.$refs.redirectIframe.getPassContainerId()
    }
  }
}
